import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { SidebarContext } from '../../../layouts/Technician/index';
import OrderServiceDetail from '../../MyOrderServices/OrderServiceDetail';
import { Badge } from 'antd';
import {
  getOrderServiceByOrderNo,
  ORDER_SERVICE_STATUS_COLOR,
  ORDER_SERVICE_STATUS_TEXT,
} from '../../../reducers/actions/orderService';

interface Props {}

const TechnicianOrderDetails: React.FC<Props> = () => {
  const { setCurrentItem, setCurrentPage } =
    useContext(SidebarContext);
  const { id } = useParams();

  const [orderServiceDetail, setOrderServiceDetail] = useState<any>();

  useEffect(() => {
    if (id) setCurrentItem(id);
    setCurrentPage('orders-detail');
  }, []);

  useEffect(() => {
    getOrderServiceByOrderNo(id as string).then((data) => {
      setOrderServiceDetail(data.data);
    });
  }, [id]);

  return (
    <Badge.Ribbon
      text={ORDER_SERVICE_STATUS_TEXT[orderServiceDetail?.status]}
      color={ORDER_SERVICE_STATUS_COLOR[orderServiceDetail?.status]}
    >
      <OrderServiceDetail id={id || ''} />
    </Badge.Ribbon>
  );
};

export default TechnicianOrderDetails;
